import { jsx as d, Fragment as E } from "react/jsx-runtime";
import l, { createContext as O, useState as g, useReducer as k, useRef as L, useMemo as w, useEffect as m, useContext as x, useCallback as A, useLayoutEffect as I } from "react";
import { createPortal as N } from "react-dom";
import * as T from "@material/dom/dist/mdc.dom.js";
const j = "@rmwc/base", F = "14.2.2", U = "RMWC base module", W = "./index.js", $ = "./index.d.ts", z = {
  ".": {
    import: "./index.mjs",
    types: "./index.d.ts",
    require: "./index.js"
  }
}, V = {
  access: "public"
}, B = {
  type: "git",
  url: "git+https://github.com/rmwc/rmwc.git"
}, q = [
  "rmwc"
], H = "rmwc", K = "MIT", G = {
  url: "https://github.com/rmwc/rmwc/issues"
}, J = "https://github.com/rmwc/rmwc/tree/master/packages/base#readme", Z = {
  react: ">=16.8.x",
  "react-dom": ">=16.8.x"
}, Q = {
  "@material/dom": "^14.0.0",
  "@rmwc/types": "workspace:*",
  classnames: "^2.3.1",
  hyperform: "^0.11.0",
  "mutation-observer": "^1.0.3",
  tslib: "^2.4.0"
}, X = {
  name: j,
  version: F,
  description: U,
  main: W,
  types: $,
  exports: z,
  publishConfig: V,
  repository: B,
  keywords: q,
  author: H,
  private: !1,
  license: K,
  bugs: G,
  homepage: J,
  peerDependencies: Z,
  dependencies: Q
};
function Y(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var S = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(t) {
  (function() {
    var e = {}.hasOwnProperty;
    function n() {
      for (var o = "", i = 0; i < arguments.length; i++) {
        var a = arguments[i];
        a && (o = r(o, s(a)));
      }
      return o;
    }
    function s(o) {
      if (typeof o == "string" || typeof o == "number")
        return o;
      if (typeof o != "object")
        return "";
      if (Array.isArray(o))
        return n.apply(null, o);
      if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
        return o.toString();
      var i = "";
      for (var a in o)
        e.call(o, a) && o[a] && (i = r(i, a));
      return i;
    }
    function r(o, i) {
      return i ? o ? o + " " + i : o + i : o;
    }
    t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
  })();
})(S);
var ee = S.exports;
const p = /* @__PURE__ */ Y(ee), te = {
  portalElement: null,
  setPortalElement: null
}, y = O(
  te
), we = ({
  children: t
}) => {
  const [e, n] = g(null);
  return /* @__PURE__ */ d(
    y.Provider,
    {
      value: {
        portalElement: e,
        setPortalElement: n
      },
      children: t
    }
  );
}, ne = (t) => t.replace(/(-[a-z])/g, (e) => e.toUpperCase().replace("-", "")), oe = (t) => t.replace(/(^[a-z]+|[A-Z][a-z]*|\d+)/g, (e) => "-" + e.toLowerCase()).slice(1), R = (t) => (Array.isArray(t) ? t : [t]).filter((n) => !!n).map((n) => `mdc-theme--${oe(n)}`), _e = (t) => {
  const e = ({ theme: n, className: s, ...r }) => {
    if (n) {
      const o = p(s, R(n));
      return /* @__PURE__ */ d(t, { className: o, ...r });
    }
    return /* @__PURE__ */ d(t, { className: s, ...r });
  };
  return e.displayName = "withTheme", e;
}, be = l.forwardRef(function({ tag: e = "div", theme: n, element: s, ...r }, o) {
  const i = s ? s.props(r) : r, a = s ? se(o, s.reactRef) : o;
  return /* @__PURE__ */ d(e, { ...i, ref: a });
}), Pe = (t, e) => p(
  t.className,
  ...t.theme ? R(t.theme) : [],
  ...typeof e == "function" ? e(t) : e
), se = (...t) => (e) => {
  for (const n of t)
    typeof n == "function" ? n(e) : n && "current" in n && (n.current = e);
}, h = (t, e) => {
  typeof t == "function" ? t(e) : t && "current" in t && (t.current = e);
};
function re(t) {
  const e = l.forwardRef(t), n = (s, r) => /* @__PURE__ */ d(E, {});
  return n.displayName = t.constructor.name || "RMWCComponent", e.displayName = n.displayName, e;
}
function Ee(t) {
  const e = re(t);
  return l.memo(e);
}
const ie = {
  blur: "onBlur",
  cancel: "onCancel",
  click: "onClick",
  close: "onClose",
  contextmenu: "onContextMenu",
  copy: "onCopy",
  cut: "onCut",
  auxclick: "onAuxClick",
  doubleclick: "onDoubleClick",
  dragend: "onDragEnd",
  dragstart: "onDragStart",
  drop: "onDrop",
  focus: "onFocus",
  input: "onInput",
  invalid: "onInvalid",
  keydown: "onKeyDown",
  keypress: "onKeyPress",
  keyup: "onKeyUp",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  paste: "onPaste",
  pause: "onPause",
  play: "onPlay",
  pointercancel: "onPointerCancel",
  pointerdown: "onPointerDown",
  pointerup: "onPointerUp",
  ratechange: "onRateChange",
  reset: "onReset",
  seeked: "onSeeked",
  submit: "onSubmit",
  touchcancel: "onTouchCancel",
  touchend: "onTouchEnd",
  touchstart: "onTouchStart",
  volumechange: "onVolumeChange",
  abort: "onAbort",
  animationend: "onAnimationEnd",
  animationiteration: "onAnimationIteration",
  animationstart: "onAnimationStart",
  canplay: "onCanPlay",
  canplaythrough: "onCanPlayThrough",
  drag: "onDrag",
  dragenter: "onDragEnter",
  dragexit: "onDragExit",
  dragleave: "onDragLeave",
  dragover: "onDragOver",
  durationchange: "onDurationChange",
  emptied: "onEmptied",
  encrypted: "onEncrypted",
  ended: "onEnded",
  error: "onError",
  gotpointercapture: "onGotPointerCapture",
  load: "onLoad",
  loadeddata: "onLoadedData",
  loadedmetadata: "onLoadedMetadata",
  loadstart: "onLoadStart",
  lostpointercapture: "onLostPointerCapture",
  mousemove: "onMouseMove",
  mouseout: "onMouseOut",
  mouseover: "onMouseOver",
  playing: "onPlaying",
  pointermove: "onPointerMove",
  pointerout: "onPointerOut",
  pointerover: "onPointerOver",
  progress: "onProgress",
  scroll: "onScroll",
  seeking: "onSeeking",
  stalled: "onStalled",
  suspend: "onSuspend",
  timeupdate: "onTimeUpdate",
  toggle: "onToggle",
  touchmove: "onTouchMove",
  transitionend: "onTransitionEnd",
  waiting: "onWaiting",
  wheel: "onWheel",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  pointerenter: "onPointerEnter",
  pointerleave: "onPointerLeave",
  change: "onChange",
  select: "onSelect",
  beforeinput: "onBeforeInput",
  compositionend: "onCompositionEnd",
  compositionstart: "onCompositionStart",
  compositionupdate: "onCompositionUpdate"
}, _ = (t) => ie[t] || t;
class ae {
  constructor(e) {
    this._classes = /* @__PURE__ */ new Set(), this._events = {}, this._style = {}, this._props = {}, this._onChange = null, this.reactRef = l.createRef(), this._onChange = e, this.onChange = this.onChange.bind(this), this.addClass = this.addClass.bind(this), this.removeClass = this.removeClass.bind(this), this.hasClass = this.hasClass.bind(this), this.setProp = this.setProp.bind(this), this.getProp = this.getProp.bind(this), this.removeProp = this.removeProp.bind(this), this.setStyle = this.setStyle.bind(this), this.addEventListener = this.addEventListener.bind(this), this.removeEventListener = this.removeEventListener.bind(this);
  }
  onChange() {
    this._onChange && this._onChange();
  }
  destroy() {
    this._onChange = null, this._events = {}, this._style = {}, this._props = {}, this._classes = /* @__PURE__ */ new Set();
  }
  /**************************************************
   * Classes
   **************************************************/
  addClass(e) {
    this._classes.has(e) || (this._classes.add(e), this.onChange());
  }
  removeClass(e) {
    this._classes.has(e) && (this._classes.delete(e), this.onChange());
  }
  hasClass(e) {
    return this._classes.has(e);
  }
  /**************************************************
   * Props
   **************************************************/
  setProp(e, n, s = !1) {
    this._props[e] !== n && (this._props[e] = n, !s && this.onChange());
  }
  getProp(e) {
    return this._props[e];
  }
  removeProp(e) {
    this._props[e] !== void 0 && (delete this._props[e], this.onChange());
  }
  props(e) {
    const { className: n = "", style: s = {} } = e, r = Object.entries(e).reduce(
      (a, [c, u]) => {
        const v = this._events[c];
        if (typeof u == "function" && typeof v == "function") {
          const D = (C) => (v(C), u(C));
          a[c] = D;
        }
        return a;
      },
      { ...this._events }
    ), o = p(n, [...this._classes]), i = {
      ...this._style,
      ...s
    };
    return {
      ...e,
      ...this._props,
      ...r,
      style: i,
      className: o
    };
  }
  /**************************************************
   * Styles
   **************************************************/
  setStyle(e, n) {
    e = e.startsWith("--") ? e : ne(e), this._style[e] !== n && (this._style[e] = n, this.onChange());
  }
  /**************************************************
   * Events
   **************************************************/
  addEventListener(e, n) {
    const s = _(e);
    this._events[s] !== n && (this._events[s] = n, this.onChange());
  }
  removeEventListener(e, n) {
    const s = _(e);
    this._events[s] && (delete this._events[s], this.onChange());
  }
  get ref() {
    return this.reactRef.current;
  }
}
const ce = (t) => (e, n, s = !1) => {
  let r;
  r = new CustomEvent(e, {
    detail: n,
    bubbles: s
  }), Object.defineProperty(r, "target", {
    value: n,
    writable: !1
  }), Object.defineProperty(r, "currentTarget", {
    value: n,
    writable: !1
  });
  const o = e;
  return t[o] && t[o](r), r;
}, xe = ({
  foundation: t,
  props: e,
  elements: n,
  api: s
}) => {
  const [, r] = k((c) => c + 1, 0), o = L(e);
  o.current = e;
  const i = w(
    () => Object.keys(n).reduce((c, u) => (c[u] = new ae(() => {
      r();
    }), c), {}),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  ), a = w(() => {
    const c = t({
      ...i,
      getProps: () => o.current,
      emit: (...u) => ce(o.current)(...u)
    });
    return s && h(o.current.apiRef, s({ foundation: c, ...i })), c;
  }, []);
  return m(() => {
    const c = a;
    return c.init(), s && h(o.current.apiRef, s({ foundation: c, ...i })), h(o.current.foundationRef, c), () => {
      c.destroy(), h(o.current.apiRef, null), h(o.current.foundationRef, null), Object.values(i).map((u) => u.destroy()), o.current = {};
    };
  }, [a, i]), { foundation: a, ...i };
}, M = "rmwcPortal", Se = (t) => {
  const e = x(y), n = e == null ? void 0 : e.setPortalElement, s = A(
    (r) => {
      r !== null && n && n(r);
    },
    [n]
  );
  return /* @__PURE__ */ d("div", { ref: s, id: M, ...t });
};
function Re({
  children: t,
  renderTo: e,
  menuSurfaceDomPositionRef: n
}) {
  const [s, r] = g(), { portalElement: o } = x(y);
  return m(() => {
    let i;
    e === !0 && o ? i = o : e === !0 ? (i = (document == null ? void 0 : document.getElementById(M)) ?? void 0, i || console.warn(
      'No default Portal found. Did you forget to include it in the root of your app? `import { Portal } from "@rmwc/base";`'
    )) : typeof e == "string" ? (i = (document == null ? void 0 : document.querySelector(e)) ?? void 0, i || console.warn(
      `The selector you provided for renderToPortal "${e}" didn't find any elements.`
    )) : e instanceof Element && (i = e), i !== s && r(i);
  }, [e, s, o]), e ? s ? /* @__PURE__ */ d("div", { ref: n, children: N(t, s) }) : null : /* @__PURE__ */ d(E, { children: t });
}
const Me = function(t, e) {
  var n;
  return function() {
    var s = this, r = arguments, o = function() {
      n = null, t.apply(s, r);
    };
    n !== null && clearTimeout(n), n = setTimeout(o, e);
  };
}, De = (t) => {
}, Oe = (t, e, n) => {
  t = { ...t };
  for (const s in e) {
    const r = e[s];
    let o, i = (a) => a;
    Array.isArray(r) ? (o = r[0], i = r[1]) : o = r, t[s] !== void 0 && (o === "" || (t[o] = i(t[s]), t[o] !== t[s] && `${t[s]}${t[o]}`), delete t[s]);
  }
  return t;
}, le = T.focusTrap.FocusTrap, ke = (t, e) => new le(t, e);
function ue() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
const de = ue() ? I : m;
let f = !1, he = 0;
function b() {
  return ++he;
}
const P = l.useId, Le = (t, e) => {
  var r;
  const n = (r = e.label) == null ? void 0 : r.replace(/\s/g, "___"), s = me(n);
  return e.id ? e.id : `${t}-${s}`;
}, me = (t) => {
  if (P !== void 0) {
    let r = P();
    return t ?? r;
  }
  let e = t ?? (f ? b() : null), [n, s] = g(e);
  return de(() => {
    n === null && s(b());
  }, []), m(() => {
    f === !1 && (f = !0);
  }, []), t ?? n ?? void 0;
}, Ae = (t, e) => {
  if (t instanceof Element) {
    if (t && t.closest)
      return t.closest(e);
    {
      let n = t;
      for (; n; ) {
        if (pe(n, e))
          return n;
        n = n.parentElement;
      }
    }
  }
  return null;
}, pe = (t, e) => (t.matches || t.webkitMatchesSelector || // @ts-ignore
t.msMatchesSelector).call(t, e), Ie = (t) => {
  const e = (Math.random() + Math.random() + 1).toString(36).substring(2);
  return `${t}-${e}`;
}, Ne = (t) => {
  const e = l.Children.only(t.children);
  return l.cloneElement(e, {
    ...t,
    ...e.props,
    className: p(t.className, e.props.className),
    style: { ...e.props.style, ...t.style }
  });
};
class fe {
  constructor() {
    this.events_ = {};
  }
  on(e, n) {
    this.events_ = this.events_ || {}, this.events_[e] = this.events_[e] || [], this.events_[e].push(n);
  }
  off(e, n) {
    this.events_ = this.events_ || {}, e in this.events_ && this.events_[e].splice(this.events_[e].indexOf(n), 1);
  }
  trigger(e, ...n) {
    if (this.events_ = this.events_ || {}, e in this.events_)
      for (var s = 0; s < this.events_[e].length; s++)
        this.events_[e][s].apply(
          this,
          Array.prototype.slice.call(arguments, 1)
        );
  }
}
class Te extends fe {
  constructor() {
    super(...arguments), this.array = [];
  }
  push(...e) {
    const n = this.array.push(...e);
    return this.trigger("change"), n;
  }
  empty() {
    this.array.length = 0, this.trigger("change");
  }
  remove(e) {
    const n = this.array.indexOf(e);
    return n > -1 ? (this.array.splice(n, 1), this.trigger("change"), !0) : !1;
  }
}
const je = (t) => {
  var s, r, o;
  const e = Array.isArray(t) ? t[0] : t;
  return ((s = e == null ? void 0 : e.type) == null ? void 0 : s.displayName) || ((r = e == null ? void 0 : e.constructor) == null ? void 0 : r.displayName) || (e == null ? void 0 : e.displayName) || (e == null ? void 0 : e.name) || ((o = e == null ? void 0 : e.constructor) == null ? void 0 : o.name) || "Unknown";
}, Fe = {
  bottom: 0,
  height: 0,
  left: 0,
  right: 0,
  top: 0,
  width: 0
}, Ue = l.createContext(!1), We = l.createContext(!1), $e = () => {
  window.dispatchEvent(new Event("resize"));
}, ge = (t, e = 1, n = 1) => {
  window.requestAnimationFrame(() => {
    n >= e ? t() : ge(t, e, n + 1);
  });
}, ze = X.version;
export {
  Te as ArrayEmitter,
  Ue as DataTableContext,
  We as DataTableHeadContext,
  fe as EventEmitter,
  ae as FoundationElement,
  Se as Portal,
  Re as PortalChild,
  y as PortalContext,
  we as PortalProvider,
  ze as RMWC_VERSION,
  be as Tag,
  p as classNames,
  Ae as closest,
  re as createComponent,
  Ee as createMemoComponent,
  Me as debounce,
  De as deprecationWarning,
  Fe as emptyClientRect,
  ie as eventsMap,
  ke as focusTrapFactory,
  je as getDisplayName,
  Oe as handleDeprecations,
  h as handleRef,
  pe as matches,
  se as mergeRefs,
  R as parseThemeOptions,
  te as portalContextDefaultValues,
  ge as raf,
  Ie as randomId,
  ne as toCamel,
  oe as toDashCase,
  $e as triggerWindowResize,
  Pe as useClassNames,
  xe as useFoundation,
  Le as useId,
  _e as withTheme,
  Ne as wrapChild
};
